import { Button, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import type { FallbackRender } from '@sentry/react';

/**
 * Fallback de nivel de feature/componente específico.
 * Se usa en boundaries alrededor de formularios complejos, calendarios o
 * cualquier componente de alto riesgo de crash aislado.
 * Diseño compacto para caber dentro de un modal o sección de página.
 */
const FeatureCrashFallback: FallbackRender = ({ error, resetError }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={1.5}
      p={3}
      minHeight={200}
      textAlign="center"
    >
      <WarningAmberIcon sx={{ fontSize: 36, color: '#f59e0b' }} />

      <Typography variant="body1" fontWeight={600} color="text.primary">
        Esta sección no está disponible en este momento
      </Typography>

      <Typography variant="body2" color="text.secondary" maxWidth={360}>
        No fue posible mostrar este contenido. Por favor, intentá nuevamente.
      </Typography>

      <Button
        variant="outlined"
        size="small"
        onClick={resetError}
        sx={{ mt: 1, borderColor: '#0050da', color: '#0050da' }}
      >
        Reintentar
      </Button>

      {import.meta.env.DEV && error instanceof Error && (
        <Box
          component="pre"
          sx={{
            mt: 2,
            p: 1.5,
            width: '100%',
            maxWidth: 480,
            overflow: 'auto',
            backgroundColor: '#1e293b',
            color: '#f1f5f9',
            borderRadius: 1,
            fontSize: '0.7rem',
            textAlign: 'left',
          }}
        >
          {error.message}
        </Box>
      )}
    </Box>
  );
};

export default FeatureCrashFallback;
